import { Box, Card } from '@zillow/constellation-10';
import { LoadingImage, LoadingText } from '@zg-rentals/loading-components';

const CardSkeleton = () => (
  <Card outlined elevated={false} dividers={false} css={{ borderRadius: '300' }}>
    <Box
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '400',
      }}
    >
      <Box css={{ display: 'flex', alignItems: 'center', gap: '400', flex: 1 }}>
        <Box css={{ flexShrink: 0, width: '800', height: '800' }}>
          <LoadingImage isLoading={true} loadingWidth="100%" loadingHeight="100%" src="" alt="" />
        </Box>
        <Box css={{ display: 'flex', flexDirection: 'column', gap: '200', flex: 1 }}>
          <Box css={{ width: '60%' }}>
            <LoadingText isLoading={true} loadingWidth="100%">
              &nbsp;
            </LoadingText>
          </Box>
          <Box css={{ width: '40%' }}>
            <LoadingText isLoading={true} loadingWidth="100%">
              &nbsp;
            </LoadingText>
          </Box>
        </Box>
      </Box>
      {/* oxlint-disable-next-line constellation/no-raw-spacing-values */}
      <Box css={{ flexShrink: 0, width: '120px', height: '800' }}>
        <LoadingImage isLoading={true} loadingWidth="100%" loadingHeight="100%" src="" alt="" />
      </Box>
    </Box>
  </Card>
);

export default CardSkeleton;
